export default "__VITE_ASSET__4fdf19ac__"